<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <div class="container">
      <b-row>
        <b-col>
          <b-card title="جزئیات محتوا">
            <b-form @submit.prevent>
              <b-row>
                <b-col
                  class="mt-2"
                  cols="12"
                  md="6"
                  offset-md="3"
                >
                  <b-row>
                    <b-col md="12">
                      <b-form-group
                        label="نوع"
                        label-for="Type"
                        class="flex-grow-1 m-0"
                      >
                        <v-select
                          v-model="Form.Type"
                          name="Type"
                          dir="rtl"
                          :reduce="x => x.value"
                          label="text"
                          input-id="Type"
                          :clearable="false"
                          :options="enums('ContentType')"
                          :disabled="isEditing"
                        />
                      </b-form-group>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col
                  v-for="(content, index) in Form.ContentDetails"
                  :key="content.Id || `item-${index}`"
                  cols="12"
                  lg="10"
                  offset-lg="1"
                  class="mt-2"
                >
                  <b-row align-v="center">
                    <b-col
                      cols="12"
                      md="11"
                    >
                      <b-row class="border rounded p-1 p-md-2 mx-0 align-items-center">
                        <b-col
                          cols="12"

                          class="mb-1"
                        >
                          <fm-file-select
                            v-model="content.Image"
                            label="عکس"
                          />
                        </b-col>

                        <!-- فیلدهای عنوان، لینک و توضیحات -->
                        <b-col
                          cols="12"
                        >
                          <b-form-group
                            label="عنوان"
                            :label-for="`Title-${index}`"
                          >
                            <b-form-input
                              :id="`Title-${index}`"
                              v-model="content.Title"
                              placeholder="عنوان محتوا را وارد کنید"
                              autocomplete="off"
                            />
                          </b-form-group>

                          <b-form-group
                            label="لینک"
                            :label-for="`URL-${index}`"
                          >
                            <b-form-input
                              :id="`URL-${index}`"
                              v-model="content.URL"
                              placeholder="https://..."
                              autocomplete="off"
                              dir="ltr"
                            />
                          </b-form-group>

                          <b-form-group
                            label="توضیحات"
                            :label-for="`Description-${index}`"
                            class="mb-0"
                          >
                            <div class="form-label-group mb-0">
                              <b-form-textarea
                                :id="`Description-${index}`"
                                v-model="content.Description"
                                name="Description"
                                placeholder="توضیحات اختیاری..."
                                autocomplete="off"
                                rows="3"
                                no-resize
                              />
                            </div>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </b-col>

                    <!-- دکمه‌های عملیاتی هر آیتم (ثبت/ویرایش و حذف) -->
                    <b-col
                      cols="12"
                      md="1"
                      class="d-flex flex-row flex-md-column align-items-center justify-content-center mt-1 mt-md-0"
                      style="gap: 8px;"
                    >
                      <!-- انصراف از حذف یا دکمه ثبت/ویرایش -->
                      <b-button
                        v-if="deleting === (content.Id || `new-${index}`)"
                        variant="secondary"
                        class="btn-icon"
                        size="sm"
                        title="انصراف از حذف"
                        @click="deleting = null"
                      >
                        <feather-icon icon="XIcon" />
                      </b-button>
                      <template v-else>
                        <b-button
                          v-if="content.Id"
                          variant="primary"
                          class="btn-icon"
                          size="sm"
                          title="ذخیره تغییرات آیتم"
                          @click="updateContent(content)"
                        >
                          <feather-icon icon="CheckIcon" />
                        </b-button>
                        <b-button
                          v-else
                          variant="primary"
                          class="btn-icon"
                          size="sm"
                          title="ثبت این آیتم جدید"
                          @click="updateContent(content)"
                        >
                          <feather-icon icon="PlusIcon" />
                        </b-button>
                      </template>

                      <!-- دکمه تایید حذف یا شروع حذف -->
                      <b-button
                        v-if="deleting === (content.Id || `new-${index}`)"
                        variant="danger"
                        class="btn-icon"
                        size="sm"
                        title="تایید و حذف قطعی"
                        @click="deleteContent(content.Id, index)"
                      >
                        <feather-icon icon="CheckIcon" />
                      </b-button>
                      <b-button
                        v-else
                        variant="danger"
                        class="btn-icon"
                        size="sm"
                        title="حذف آیتم"
                        @click="deleting = (content.Id || `new-${index}`)"
                      >
                        <feather-icon icon="Trash2Icon" />
                      </b-button>
                    </b-col>
                  </b-row>
                </b-col>

                <!-- دکمه‌های عملیات کلی فرم -->
                <b-col
                  v-if="!isEditing && !saved"
                  cols="12"
                  class="mt-2 mb-2 text-center"
                >
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    type="submit"
                    variant="primary"
                    class="mr-1"
                    @click="save"
                  >
                    ذخیره
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    variant="outline-secondary"
                    @click="back"
                  >
                    بازگشت
                  </b-button>
                </b-col>
                <b-col
                  v-else
                  cols="12"
                  class="mt-2 text-center d-flex justify-content-center align-items-center"
                  style="gap: 10px;"
                >
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="gradient-info"
                    @click="addContentDetails"
                  >
                    <feather-icon
                      icon="PlusIcon"
                      class="mr-25"
                    />
                    <span>افزودن</span>
                  </b-button>
                  <b-button
                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                    variant="outline-secondary"
                    @click="back"
                  >
                    بازگشت
                  </b-button>
                </b-col>
              </b-row>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </b-overlay>
</template>

<script>
import FmFileSelect from '@/views/menu/file-manager/components/fmFileSelect.vue'

export default {
  name: 'ContentDetails',
  components: { FmFileSelect },
  data() {
    return {
      Form: {
        Id: null,
        ContentDetails: [],
        Type: null,
      },
      loading: false,
      saved: false,
      deleting: null,
    }
  },
  computed: {
    editing() {
      return this.$route.params.id
    },
    isEditing() {
      return this.editing !== undefined && this.editing !== null && this.editing !== ''
    },
  },
  watch: {
    editing: {
      immediate: true,
      handler(val) {
        if (val !== '' && val !== undefined && val !== null) this.get()
      },
    },
  },
  methods: {
    get() {
      this.loading = true
      this.$http.post(
        this.$api.content.get, {
          Type: this.editing,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data || { Id: null, ContentDetails: [], Type: null }
          if (!this.Form.ContentDetails) {
            this.$set(this.Form, 'ContentDetails', [])
          }
        }).catch(() => {
          this.loading = false
        })
    },
    save() {
      if (this.Form.Type === null || this.Form.Type === undefined) {
        this.$bvToast.toast('لطفا نوع محتوا را انتخاب کنید', {
          title: 'خطا در انجام عملیات',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          solid: false,
          appendToast: true,
        })
        return
      }

      this.loading = true
      const url = this.$api.content.addDetails
      const data = { Type: this.Form.Type }

      this.$http.post(url, data)
        .then(response => {
          this.loading = false
          this.saved = true
          if (response.data) {
            if (typeof response.data === 'object') {
              this.Form = { ...this.Form, ...response.data }
            } else {
              this.Form.Id = response.data
            }
          }
          if (!this.Form.ContentDetails) {
            this.$set(this.Form, 'ContentDetails', [])
          }
          if (this.Form.Type !== null && this.Form.Type !== undefined) {
            this.$router.replace({ name: 'updatecontent', params: { id: this.Form.Type } })
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    addContentDetails() {
      if (!this.Form.ContentDetails) {
        this.$set(this.Form, 'ContentDetails', [])
      }
      const item = {
        Id: null,
        Title: '',
        Description: '',
        Image: null,
        URL: '',
        ContentId: this.Form.Id,
      }
      this.Form.ContentDetails.push(item)
    },
    deleteContent(id, index) {
      if (!id) {
        this.Form.ContentDetails.splice(index, 1)
        this.deleting = null
        return
      }

      this.loading = true
      this.$http.post(
        this.$api.content.removeDetails, { Id: id },
      ).then(() => {
        this.loading = false
        this.deleting = null
        const foundIdx = this.Form.ContentDetails.findIndex(i => i.Id === id)
        if (foundIdx !== -1) {
          this.Form.ContentDetails.splice(foundIdx, 1)
        } else if (index >= 0 && index < this.Form.ContentDetails.length) {
          this.Form.ContentDetails.splice(index, 1)
        }
      }).catch(() => {
        this.deleting = null
        this.loading = false
      })
    },
    updateContent(item) {
      if (!item.Title || !String(item.Title).trim()) {
        this.$bvToast.toast('لطفا عنوان محتوا را وارد کنید', {
          title: 'خطا در انجام عملیات',
          toaster: 'b-toaster-bottom-right',
          variant: 'danger',
          solid: false,
          appendToast: true,
        })
        return
      }

      this.loading = true
      const url = item.Id ? this.$api.content.updateDetails : this.$api.content.addDetails
      const payload = {
        Id: item.Id || 0,
        ContentId: item.ContentId || this.Form.Id,
        Title: item.Title,
        Description: item.Description || '',
        Image: item.Image || null,
        URL: item.URL || '',
      }

      this.$http.post(url, payload)
        .then(response => {
          this.loading = false
          const newId = (typeof response.data === 'object' && response.data)
            ? (response.data.Id || response.data.id)
            : response.data
          if (!item.Id && newId) {
            this.$set(item, 'Id', newId)
          }
          if (!item.ContentId && this.Form.Id) {
            this.$set(item, 'ContentId', this.Form.Id)
          }
        }).catch(() => {
          this.loading = false
        })
    },
    back() {
      this.$router.push({ name: 'content' })
    },
  },
}
</script>
